<template>
  <div class="main">
    <div ref="queryContent" v-sticky="{zIndex: 2001, stickyTop: 0, disabled: false}">
      <div class="header-wrapper">
        <el-form :disabled="isListLoading" :model="queryForm" ref="queryForm" :inline="true" label-width="0" :show-message="false">
          <div class="d-flex justify-content-between">
            <div class="filter-wrapper mr-2">
              <div class="filter-container">
                <div class="filter-item mr-3">
                  <label>渠道名称：</label>
                  <el-form-item prop="name" class="inline-form-item">
                    <el-input v-model.trim="queryForm.name" clearable class="filter-input"></el-input>
                  </el-form-item>
                </div>
                <div class="filter-item mr-3">
                  <label>状态：</label>
                  <el-form-item prop="status" class="inline-form-item">
                    <el-select v-model="queryForm.status" class="filter-input">
                      <el-option label="全部状态" :value="null"></el-option>
                      <el-option
                        v-for="item in statusOptions"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="filter-item">
                  <el-button :loading="isListLoading" :disabled="isStatusChanging" @click="fetchData" type="primary" class="query-button" icon="el-icon-search">查询</el-button>
                  <el-button :disabled="isListLoading || isStatusChanging" @click="resetQueryForm" class="query-button">重置</el-button>
                </div>
              </div>
            </div>
            <div class="tools flex-shrink-0">
              <div class="filter-item">
                <el-button :disabled="isListLoading || isStatusChanging" @click="edit('')" type="warning" class="query-button">新增渠道</el-button>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="content-wrapper">
      <div class="main-content">
        <el-table
          ref="table"
          :data="rawListData"
          v-loading="isListLoading"
          border
          fit
          highlight-current-row
          style="width: 100%;"
          :max-height="tableMaxHeight">
          <el-table-column
            prop="Id"
            label="渠道ID">
          </el-table-column>
          <el-table-column
            min-width="180"
            prop="Name"
            label="渠道名称">
          </el-table-column>
          <el-table-column
            min-width="80"
            prop="BackTimes"
            label="返回次数">
          </el-table-column>
          <el-table-column
            min-width="120"
            prop="YesterdayCount"
            label="昨日总阅读量">
          </el-table-column>
          <el-table-column
            min-width="250"
            label="访问链接">
            <template slot-scope="scope">
              <div>{{ baseUrl + scope.row.Id }}</div>
              <el-button @click="copyUrl($event, scope.row.Id)" type="primary" round plain size="mini">复制</el-button>
            </template>
          </el-table-column>
          <el-table-column
            min-width="140"
            prop="CreateTime"
            label="添加时间">
          </el-table-column>
          <el-table-column
            label="状态">
            <template slot-scope="scope">
              <div>{{ statusMap.get(scope.row.Status) }}</div>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="180">
            <template slot-scope="scope">
              <el-button @click="edit(scope.row)" type="text">修改</el-button>
              <el-button @click="viewData(scope.row)" type="text">查看数据</el-button>
              <el-button
                @click="changeStatus(scope.row)"
                :loading="isStatusChanging && currentId === scope.row.Id"
                :disabled="isListLoading || (isStatusChanging && currentId !== scope.row.Id)"
                type="text"
              >{{ +scope.row.Status === 1 ? '禁用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="text-center py-3">
          <el-pagination
            :disabled="isListLoading"
            @current-change="handleCurrentChange"
            @size-change="handlePageSizeChange"
            :current-page.sync="tableCurrentPage"
            :page-sizes="tablePageSizeOption"
            :page-size="tablePageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableTotalSize"
            background>
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :title="`${form.id ? '修改' : '新增'}渠道`"
      width="450px"
      class="edit-channel-dialog"
    >
      <el-form
        v-loading="isSaving"
        :rules="rules"
        :hide-required-asterisk="true"
        label-width="90px"
        :model="form"
        ref="form">
        <el-form-item label="渠道名称：" prop="name" class="form-item">
          <el-input v-model.trim="form.name" class="form-input"></el-input>
        </el-form-item>
        <el-form-item label="返回次数：" prop="backTimes" class="form-item">
          <el-input-number
            v-model="form.backTimes"
            :step="1"
            :min="0"
            step-strictly
            controls-position="right"
            class="form-input">
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button @click="save" type="primary" class="save-btn">确认保存</el-button>
          <el-button @click="dialogVisible = false" class="cancel-btn">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'
import * as JumpAmountApi from '@/api/jumpAmount'
import AccountApi from '@/api/Account'
import swal from 'sweetalert2'
import { deepClone } from '@/utils'
import handleClipboard from '@/utils/clipboard'

export default {
  name: 'jump-amount-channel-management',
  directives: {
    sticky: VueSticky
  },
  data() {
    const name = null
    const status = null

    return {
      queryForm: {
        // 渠道名称
        name,
        // 状态
        status
      },
      statusOptions: [
        {
          name: '启用',
          value: '1'
        }, {
          name: '禁用',
          value: '0'
        }
      ],

      isListLoading: false,
      isStatusChanging: false,

      currentId: null,

      dialogVisible: false,
      isSaving: false,

      form: {
        id: null,
        name: null,
        backTimes: null
      },

      rules: {
        name: [{ required: true, message: '请填写', trigger: ['blur', 'change'] }],
        backTimes: [{ required: true, message: '请填写', trigger: ['blur', 'change'] }]
      },

      baseUrl: '',

      // 保存之前的请求参数
      query: deepClone({ name, status }),

      rawListData: [],

      // 表格当前页
      tableCurrentPage: 1,
      // 表格一页条数可选项
      tablePageSizeOption: [10, 20, 30],
      // 表格一页条数
      tablePageSize: 20,
      // 总条数
      tableTotalSize: 0,

      // 除表格外内容区域高度
      othersHeight: 0
    }
  },
  computed: {
    statusMap() {
      return new Map(this.statusOptions.map(item => [item.value, item.name]))
    },
    tableMaxHeight() {
      return Math.max(this.$store.getters.containerHeight - this.othersHeight, 300)
    }
  },
  created() {
    this.getJumpLinkUrl()
    this.fetchData()
  },
  mounted() {
  },
  updated() {
    this.$nextTick(() => {
      const queryContent = this.$refs.queryContent
      const queryContentHeight = queryContent ? Math.round(queryContent.clientHeight) : 0
      this.othersHeight = queryContentHeight + 41 + 64
    })
  },
  deactivated() {
    this.dialogVisible = false
  },
  methods: {
    // 重置查询
    resetQueryForm() {
      this.$refs.queryForm.resetFields()
    },
    getJumpLinkUrl() {
      AccountApi.getInfoByName({ name: 'jumpLinkConfig' }).then(({ data }) => {
        if (data.Status === 200) {
          if (data.Result.length > 0) {
            this.baseUrl = data.Result[0].value
          }
        }
      })
    },
    fetchData() {
      // 克隆当前查询条件
      this.query = deepClone(this.queryForm)
      this.tableCurrentPage = 1
      this.tableTotalSize = 0

      this.fetchList()
    },
    fetchList() {
      this.isListLoading = true
      this.rawListData = []

      const { name, status } = this.query

      const postData = {
        page: this.tableCurrentPage,
        limit: this.tablePageSize
      }
      name && (postData.name = name)
      status && (postData.status = status)

      JumpAmountApi.getArticleChannelPageList(postData).then(({ data }) => {
        this.isListLoading = false
        if (data.Status !== 200) {
          swal({
            text: data.Result.ErrorMsg,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }
        this.rawListData = data.Result.list
        this.tableTotalSize = parseInt(data.Result.count) || 0
      }).catch(error => {
        swal({
          text: error.message,
          type: 'error',
          timer: 2000,
          showConfirmButton: false
        })
        this.isListLoading = false
      })
    },
    handleCurrentChange(value) {
      this.fetchList()
    },
    handlePageSizeChange(value) {
      this.tableCurrentPage = 1
      this.tablePageSize = value
      this.fetchList()
    },
    // 修改状态
    changeStatus(row) {
      this.currentId = row.Id
      this.$confirm(`确定要${+row.Status === 1 ? '禁用' : '启用'}渠道“${row.Name}”吗？`, '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.isStatusChanging = true
        const postData = {
          id: row.Id,
          status: +row.Status === 1 ? 0 : 1
        }
        JumpAmountApi.editArticleChannelStatus(postData).then(({ data }) => {
          this.isStatusChanging = false
          if (data.Status !== 200) {
            this.$message({
              message: data.Result.ErrorMsg,
              type: 'error',
              duration: 2000
            })
            return
          }
          this.$message({
            message: `${+row.Status === 1 ? '禁用' : '启用'}成功`,
            type: 'success',
            duration: 2000
          })
          this.fetchList()
        }).catch(() => {
          this.isStatusChanging = false
        })
      }).catch(() => {
      })
    },
    edit(row) {
      if (row) {
        this.form = {
          id: row.Id,
          name: row.Name,
          backTimes: parseFloat(row.BackTimes)
        }
      } else {
        this.form = {
          id: null,
          name: null,
          backTimes: null
        }
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    // 保存
    save() {
      this.$refs.form.validate().then(() => {
        this.isSaving = true

        const { id, name, backTimes } = this.form
        const postData = {
          name,
          backTimes
        }
        let method = 'addArticleChannel'
        if (id) {
          method = 'editArticleChannel'
          postData.id = id
        }

        JumpAmountApi[method](postData).then(({ data }) => {
          this.isSaving = false
          if (data.Status !== 200) {
            this.$message({
              message: data.Result.ErrorMsg,
              type: 'error',
              duration: 2000
            })
            return false
          }
          this.$message({
            message: '保存成功',
            type: 'success',
            duration: 2000
          })
          if (id) {
            this.fetchList()
          } else {
            this.fetchData()
          }
          this.dialogVisible = false
        }).catch(() => {
          this.isSaving = false
        })
      }).catch(() => {
        this.$message({
          message: '请正确填写各项内容',
          type: 'error',
          duration: 2000
        })
        this.$nextTick(() => {
          const field = this.$refs.form.$el.querySelector('.el-form-item.is-error .el-input:not(.d-none) input, .el-form-item.is-error .el-select:not(.d-none) input, .el-form-item.is-error .el-textarea:not(.d-none) textarea')
          field && field.focus()
        })
      })
    },
    copyUrl(event, id) {
      handleClipboard(this.baseUrl + id, event)
    },
    viewData(row) {
      this.$router.push({
        path: '/jump-amount-daily-stats',
        query: {
          channel: row.Id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  display: table;
  table-layout: fixed;
  min-width: 1300px;
  width: 100%;
  height: 100%;
  background-color: #ececec;
  .filter-item {
    margin-bottom: 15px;
  }
  .filter-container {
    .filter-item {
      display: inline-block;
      white-space: nowrap;
    }
  }
  .filter-input {
    width: 200px;
  }
  .query-button {
    width: 100px;
  }
  .tool-button {
    width: 100px;
  }
  .oper-button {
    width: 80px;
  }
  .header-wrapper {
    padding: 14px 20px 0;
    box-shadow: 0 1px 3px rgba(0,0,0,.1);
    background-color: #fff;
  }
  .content-wrapper {
    padding: 20px;
    .main-content {
      border-top: 1px solid #e1e3e4;
      border-left: 1px solid #e1e3e4;
      border-right: 1px solid #e1e3e4;
      background-color: #fff;
      .button-wrapper {
        padding: 20px 20px;
      }
    }
  }
  .inline-form-item {
    display: inline-block;
    margin: 0;
    vertical-align: middle;
  }
  .save-btn,
  .cancel-btn {
    width: 100px;
  }
  .el-input-number {
    /deep/ .el-input__inner {
      text-align: left;
    }
  }
  .form-input {
    width: 100%;
  }
}
</style>
